import { isDefined } from '@sgme/fp';
import { FieldMetadataById } from 'state/common-form/metaData/fields/fields.model';

export const RELATED_PARENT_FIELD_ID_BY_PATCHED_FIELD_ID: Readonly<Record<string, string>> = {
  ScheduleDates: 'ScheduleDatesModal',
  SwapSchedule: 'SwapScheduleModal',
  ExerciseSchedule: 'ExerciseScheduleModal',
  DealSplit: 'DealSplitModal',
};

export function getBatchParentFieldId(fieldId: string, fieldsMetadata: FieldMetadataById): string | undefined {
  const batchParentFieldId = RELATED_PARENT_FIELD_ID_BY_PATCHED_FIELD_ID[fieldId];
  return isDefined(batchParentFieldId) && batchParentFieldId in fieldsMetadata ? batchParentFieldId : undefined;
}
